<template>
  <!--商品轮播图组件-->
  <div class="img-box">
    <van-swipe @change="onChange" :autoplay="5000">
      <van-swipe-item
        v-for="(s, num) in commodityImage"
        :key="num"
        @click="viewImage(num)"
      >
        <img
          class="tkImage"
          :style="{width: width + '%', height: height + 'px'}"
          :src="s"
        >
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          {{ current + 1 }}/{{commodityImage.length}}
        </div>
      </template>
    </van-swipe>
    <!--查看大图cover-->
    <tk-cover
      :show.sync="isWatch"
      :hideOnClick="false"
      transition
      color="rgba(255, 255, 255, 0)"
      :through="false"
    >
      <!--由于下载原因 去掉开始索引:start-position="watchNum"-->
      <van-image-preview
        v-model="isWatch"
        :images="commodityImage"
        closeable
        closeIcon="cross"
        closeOnPopstate
        show-index
        :start-position="viewIndex"
        @change="changeView"
        ref="merchandiseCarousel"
        @touchstart.native="gtouchstart($event)"
        @touchmove.native="gtouchmove()"
        @touchend.native="gtouchend()"
        @close="isWatch = false"
        className="extend-class"
      >
        <template v-slot:index>{{ viewIndex + 1 + ' / ' + commodityImage.length }}</template>
      </van-image-preview>
      <tk-flex
        middle
        center
        v-if="touchDownStatus && isWatch"
        class="view-down-load animate__animated
        animate__fadeInUp font-15"
        @click.native="downLoad"
      >
        <tk-icon :size="12" color="white" style="height: 15px;padding-top: 2px;" class="m-r-2">xiazai</tk-icon>
        保存到手机
      </tk-flex>
      <!--下载弹框-->
      <tkui-dialog closeIcon hideAction :show.sync="isDownLoadStatus" center>
        <div class="subhead">
          <tk-flex column class="p-r-24">
            <div class="font-14">{{!downError ? '下载：' + fileName : downError}}</div>
            <div class="m-t-15 font-12"> {{'下载进度：' + percent + '%'}}</div>
          </tk-flex>
          <load-progress
            class="m-t-15"
            v-if="percent"
            :percent="percent"
            :progress-show="true"
            type="rect"
            :rect-width="230"
            :rect-height="5"
            :pathColors="['#f5f5f5', '#7f7eff']"
            :text-color="'rgba(255, 255, 255, 0)'"
          ></load-progress>
        </div>
      </tkui-dialog>
    </tk-cover>
  </div>
</template>

<script>
import { ImagePreview, Swipe, SwipeItem } from 'vant'
import loadProgress from '@/components/loadProgress'
import { readyToDownloadFromNet } from '@/assets/help/download'
import { getImageName, waterMarkImage } from '@/assets/help/tool'
export default {
  data () {
    return {
      current: 0,
      viewIndex: 0,
      fileName: null, // 当前下载的文件
      touchDownStatus: false, // 长按下载状态
      timeOutEvent: 0, // 长按延时器定义
      isDownLoadStatus: false, // 下载状态
      percent: 0, // 下载进度
      downError: null, // 下载提示
      watchNum: 0, // 查看大图的起始位置
      isWatch: false // 是否查看大图
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    loadProgress
  },
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    commodityImage: {
      type: Array,
      required: true
    }
  },
  watch: {
    isWatch (val) {
      if (!val) {
        this.touchDownStatus = false
      }
    }
  },
  methods: {
    /**
     * 查看大图
     * @date: 2020/5/21
     */
    async viewImage (num) {
      this.isWatch = true
      this.viewIndex = num
      await this.$tkHelper.sleep(0)
      if (this.$refs.merchandiseCarousel) {
        this.$refs.merchandiseCarousel.swipeTo(num)
      }
    },
    /**
    * 获取当前索引
    * @date: 2020/5/21
    */
    onChange (index) {
      this.current = index
    },
    changeView (num) {
      this.viewIndex = num
      this.touchDownStatus = false
    },
    /**
     * 长按操作
     * @date: 2020/8/21
     */
    gtouchstart (e) {
      this.timeOutEvent = setTimeout(() => {
        this.touchDownStatus = true
      }, 500)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend () {
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        // alert('你这是点击，不是长按')
        // recipient 接收人 replytoe 回复人
      }
      return false
    },
    /**
     * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
     * @date: 2020/8/21
     */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
     * 下载图片保存手机
     * @date: 2020/9/4
     */
    async downLoad () {
      let url = waterMarkImage(this.commodityImage[this.viewIndex])
      this.fileName = getImageName(this.commodityImage[this.viewIndex])
      this.isDownLoadStatus = true
      let percent = new Promise(resolve => {
        readyToDownloadFromNet(url, 'image', this.fileName, {
          downloading: async (progress, text) => {
            this.percent = progress
            if (this.percent === 100) {
              await this.$tkHelper.sleep(300)
              this.isDownLoadStatus = false
              resolve(progress)
            }
          },
          errorDownload: (error) => {
            this.percent = null
            this.downError = error
            this.isDownLoadStatus = false
            resolve(-1)
          }
        })
      })
      let judgePercent = await percent
      // 修改数据库
      if (judgePercent === -1) {
        this.isDownLoadStatus = false
        return this.$tkGlobal.toast.add('下载失败')
      }
      if (judgePercent === 100) {
        this.$tkGlobal.toast.add('下载成功')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /*轮播图样式*/
  .img-box {
    height: 375px;
    .tkImage {
      object-fit: cover;
      height: 100%;
    }
    .custom-indicator {
      position: absolute;
      right: 0;
      bottom: 5px;
      padding: 2px 5px;
      color: #fff;
      font-size: 12px;
      min-width: 50px;
      text-align: center;
      border-radius: 15px 0 0 15px;
      background: rgba(0, 0, 0, 0.3);
    }
  }
  .view-down-load {
    position: absolute;
    z-index: 3000;
    bottom: 10%;
    color: #ffffff;
    width: 124px;
    left: calc((100vw - 124px) / 2);
    overflow: hidden;
    padding: 6px 15px 7px 15px;
    white-space: nowrap;
    background-color: #525252;
    border-radius: 25px;
  }
</style>
